export default __webpack_public_path__ + "static/media/fr-asia-6.5cc86c40.jpg";